import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromoClick, trackPromoShow } from './tracking';
import { createAnalyticsProduct } from './utils';
import { openPromoDetails } from '../../actions/promoDetails';
import { LowRateMortgagePromos } from '../../components/LowRateMortgagePromos';
import { selectPage } from '../../selectors/analytics';
import { selectLowRateMortgagePromos, selectLowRateMortgageTitle } from '../../selectors/promosPage';
import { ILowRateMortgagePromo } from '../../types/promosPage';

export const LowRateMortgagePromosContainer = () => {
  const title = useSelector(selectLowRateMortgageTitle);
  const promoList = useSelector(selectLowRateMortgagePromos);
  const page = useSelector(selectPage);
  const dispatch = useDispatch();

  const handlePromoShow = React.useCallback(
    (promo: ILowRateMortgagePromo, position: number) => {
      trackPromoShow({ page, position, promo });
    },
    [page],
  );

  const handlePromoClick = React.useCallback(
    (promo: ILowRateMortgagePromo, position: number) => {
      dispatch(
        openPromoDetails({
          promo: promo.popup,
          product: createAnalyticsProduct(promo, position),
        }),
      );
      trackPromoClick({ page, position, promo });
    },
    [dispatch, page],
  );

  if (!promoList.length) {
    return null;
  }

  return (
    <LowRateMortgagePromos
      title={title}
      promoList={promoList}
      onPromoClick={handlePromoClick}
      onPromoShow={handlePromoShow}
    />
  );
};
